import React from 'react';
import { Button } from './ui/button';
import { CreditCard, Calculator, Coffee, FileText } from 'lucide-react';

const ServiceCards = () => {
  const services = [
    {
      icon: CreditCard,
      title: 'Need a Bank Account?',
      subtitle: 'Open a corporate bank account with zero hassle',
      description: 'Opening a corporate bank account is integral to the business setup process. Firmzy has established partnerships with multiple banks, and we will find the bank that best suits your needs. We will guide you through opening your corporate bank account and assist you in preparing all the requirements to get started.',
      link: '#banking',
      bgColor: 'from-cyan-400 to-cyan-600',
      image: 'https://images.unsplash.com/photo-1638262052640-82e94d64664a?w=600&q=80',
    },
    {
      icon: Calculator,
      title: 'Need help with Corporate Tax Registration or Filing?',
      subtitle: 'End-to-End Tax and Accounting Services',
      description: 'Our team of experienced professionals is dedicated to ensuring that every aspect of your tax and accounting requirements is handled with care. From gathering the necessary documentation and registering for corporate tax to preparing financial statements and bookkeeping, we provide comprehensive support.',
      link: '#tax',
      bgColor: 'from-purple-400 to-purple-600',
      image: 'https://images.unsplash.com/photo-1664382951020-41874ae61a44?w=600&q=80',
    },
    {
      icon: Coffee,
      title: 'Need a Co-working Solution?',
      subtitle: 'Get access to our business centre and co-working solutions',
      description: 'Experience state-of-the-art office facilities in Chennai, paired with unrivaled customer support that\'s tailored to your needs. Our Business Hub\'s wide range of concierge services, facilities, and amenities will help you manage your operations seamlessly & successfully.',
      link: '#coworking',
      bgColor: 'from-orange-400 to-orange-600',
      image: 'https://images.unsplash.com/photo-1703355685722-2996b01483be?w=600&q=80',
    },
    {
      icon: FileText,
      title: 'Need Business Registration Assistance?',
      subtitle: 'Complete registration and compliance support',
      description: 'Whether you require a Private Limited company, LLP, or OPC registration, our dedicated team is ready to assist you in organizing all types of registrations and compliance requirements for you and your business.',
      link: '#registration',
      bgColor: 'from-green-400 to-green-600',
      image: 'https://images.pexels.com/photos/2977565/pexels-photo-2977565.jpeg?w=600&q=80',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, idx) => {
            const IconComponent = service.icon;
            return (
              <div
                key={idx}
                className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                {/* Background Image with Overlay */}
                <div 
                  className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity"
                  style={{
                    backgroundImage: `url(${service.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                ></div>

                {/* Gradient Accent Bar */}
                <div className={`h-2 bg-gradient-to-r ${service.bgColor}`}></div>

                <div className="relative p-8">
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${service.bgColor} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                    <IconComponent className="text-white" size={32} />
                  </div>

                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    {service.title}
                  </h3>
                  <p className={`text-lg font-semibold bg-gradient-to-r ${service.bgColor} bg-clip-text text-transparent mb-4`}>
                    {service.subtitle}
                  </p>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>

                  <Button 
                    className={`bg-gradient-to-r ${service.bgColor} text-white hover:shadow-lg transition-all`}
                  >
                    Learn More →
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;